module.exports = __webpack_public_path__ + "img/iconfont.b0a61e8c.svg";